import { render, staticRenderFns } from "./safe-area-top.vue?vue&type=template&id=9c2cd0dc&scoped=true&lang=pug"
import script from "./safe-area-top.vue?vue&type=script&lang=js"
export * from "./safe-area-top.vue?vue&type=script&lang=js"
import style0 from "./safe-area-top.vue?vue&type=style&index=0&id=9c2cd0dc&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2cd0dc",
  null
  
)

export default component.exports